import { useNode } from '@craftjs/core';
import { defaultBorderStyle, LayoutPanel, StylesPanel } from 'src/features/generalForms/builder/layout/panels';
import { FormDividingLineComponent } from 'src/features/generalForms/builder/types/DividingLine';

export const FormDividingLine: FormDividingLineComponent = ({}) => {
  const { connectors, styles } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const { connect, drag } = connectors;

  const { paddingTop, paddingBottom, ...restStyles } = styles;

  return (
    <div
      ref={(ref: HTMLDivElement) => connect(drag(ref))}
      style={{
        paddingTop: paddingTop,
        paddingBottom: paddingBottom,
        boxSizing: 'border-box',
      }}
    >
      <div style={{ ...restStyles, borderBottom: 0 }} />
    </div>
  );
};

const formFormDividingLineDefaultStylesFactory = (): React.CSSProperties => {
  return {
    paddingTop: 16,
    paddingBottom: 16,
    borderColor: defaultBorderStyle.borderColor,
    borderWidth: defaultBorderStyle.borderWidth,
    borderStyle: defaultBorderStyle.borderStyle,
  } satisfies React.CSSProperties;
};

const FormDividingLineSettings = () => (
  <>
    <LayoutPanel sections={['Paddings']} />
    <StylesPanel sections={['Border']} />
  </>
);

FormDividingLine.craft = {
  displayName: 'DividingLine',
  custom: formFormDividingLineDefaultStylesFactory(),
  rules: {
    canDrag: () => true,
  },
  related: {
    settings: FormDividingLineSettings,
  },
};

export default { FormDividingLine };
